/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Notification } from '../model';
/**
 * UserNotificationApi - axios parameter creator
 * @export
 */
export const UserNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the list of notifications
         * @summary List of a users notifications for the past 30 days
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerNotificationList: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationApi - functional programming interface
 * @export
 */
export const UserNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the list of notifications
         * @summary List of a users notifications for the past 30 days
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerNotificationList(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerNotificationList(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserNotificationApi - factory interface
 * @export
 */
export const UserNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserNotificationApiFp(configuration)
    return {
        /**
         * Returns the list of notifications
         * @summary List of a users notifications for the past 30 days
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerNotificationList(aaSource?: string, options?: any): AxiosPromise<Array<Notification>> {
            return localVarFp.sellerNotificationList(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerNotificationList operation in UserNotificationApi.
 * @export
 * @interface UserNotificationApiSellerNotificationListRequest
 */
export interface UserNotificationApiSellerNotificationListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserNotificationApiSellerNotificationList
     */
    readonly aaSource?: string
}

/**
 * UserNotificationApi - object-oriented interface
 * @export
 * @class UserNotificationApi
 * @extends {BaseAPI}
 */
export class UserNotificationApi extends BaseAPI {
    /**
     * Returns the list of notifications
     * @summary List of a users notifications for the past 30 days
     * @param {UserNotificationApiSellerNotificationListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationApi
     */
    public sellerNotificationList(requestParameters: UserNotificationApiSellerNotificationListRequest = {}, options?: any) {
        return UserNotificationApiFp(this.configuration).sellerNotificationList(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
